<template>
  <modal
    name="add-customer-account-modal"
    :height="isMobile ? '100%' : 'auto'"
    :width="isMobile ? '100%' : '40%'"
    :scrollable="true"
    @opened="onOpen"
  >
    <!-- Header-->
    <div
      class="pt-3 pb-2 pr-4 pl-4 h-12 border-gray-100 dark:border-gray-500 dark:bg-gray-900 dark:text-gray-200"
    >
      <h4 class="inline-block w-11/12">
        Müşteri Hesabı Oluştur
      </h4>
      <button @click="$modal.hide('add-customer-account-modal')" class="w-1/12">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <!-- Header-->

    <!-- Body-->
    <form
      @submit.prevent="save"
      class="p-4 bg-white dark:bg-gray-900 text-black dark:text-gray-200 border-gray-200 border-b border-t border-opacity-30 overflow-y-auto h-full pb-20 xl:h-auto xl:pb-3"
    >
      <div class="w-full mb-3 p-3 bg-gray-50 dark:bg-gray-800 rounded border border-gray-200 dark:border-gray-600">
        <p class="text-xs text-gray-500 dark:text-gray-400">Müşteri</p>
        <p class="text-sm font-medium text-gray-800 dark:text-gray-200">{{ customerName }}</p>
      </div>

      <div class="w-full mt-4">
        <diffInput
          title="Kullanıcı Adı"
          type="Text"
          v-model="username"
          :required="true"
        />
      </div>
      <div class="w-full mt-4">
        <diffInput
          title="Ad Soyad"
          type="Text"
          v-model="fullname"
          :required="true"
        />
      </div>
      <div class="w-full mt-4">
        <diffInput
          title="E-posta"
          type="email"
          v-model="email"
        />
      </div>
      <div class="w-full mt-4">
        <diffInput
          title="Pozisyon"
          type="Text"
          v-model="authority"
        />
      </div>

      <div class="md:flex">
        <div class="w-full md:w-6/12 mt-4 md:mr-2">
          <div
            class="w-full flex relative border border-gray-300 p-3 pt-4 rounded dark:border-gray-500"
          >
            <h6
              class="absolute -top-3 bg-white pr-2 pl-2 dark:bg-gray-900 dark:text-gray-300 rounded"
            >
              Parola
            </h6>
            <VuePassword
              v-model="password"
              class="w-full border-black rounded-r"
              classes="h-12 bg-gray-50 text-lg focus:ring-0 rounded-r dark:bg-gray-800 dark:border-gray-500"
              disableStrength
            />
          </div>
        </div>
        <div class="w-full md:w-6/12 mt-4 md:mr-2">
          <div
            class="w-full flex relative border border-gray-300 p-3 pt-4 rounded dark:border-gray-500"
          >
            <h6
              class="absolute -top-3 bg-white pr-2 pl-2 dark:bg-gray-900 dark:text-gray-300 rounded"
            >
              Parola Tekrar
            </h6>
            <VuePassword
              v-model="passwordAgain"
              class="w-full border-black rounded-r"
              classes="h-12 bg-gray-50 text-lg focus:ring-0 rounded-r dark:bg-gray-800 dark:border-gray-500"
              disableStrength
            />
          </div>
        </div>
      </div>

      <div class="w-full mt-4 text-right">
        <asyncBtn
          icon="fas fa-check"
          :text="$t('general.saveButtonTitle')"
          :loadTitle="$t('general.saveButtonLoadTitle')"
          :loadState="load"
          class="w-full md:w-56"
        />
      </div>
    </form>
    <!-- Body-->
  </modal>
</template>

<script>
//npm
import VuePassword from "vue-password";

//Global Components
import diffInput from "@/components/general/diffInput.vue";
import asyncBtn from "@/components/general/asyncBtn.vue";

//networking
import axios from "axios";
import { managementUser } from "@/networking/urlmanager";

export default {
  name: "add-customer-account-modal",
  props: ["customer"],
  components: {
    VuePassword,
    diffInput,
    asyncBtn,
  },
  data() {
    return {
      username: "",
      fullname: "",
      email: "",
      authority: "",
      password: "",
      passwordAgain: "",
      load: false,
    };
  },
  computed: {
    customerName() {
      return this.customer?.name || "";
    },
  },
  methods: {
    onOpen() {
      this.fullname = "";
      this.username = "";
      this.email = "";
      this.authority = "";
      this.password = "";
      this.passwordAgain = "";
    },
    save() {
      if (this.password !== this.passwordAgain) {
        this.errorBox({
          status: 400,
          data: {
            message: "Girilen Parolalar Uyuşmamaktadır",
          },
        });
        return;
      }

      this.load = true;
      axios
        .post(
          managementUser.add,
          {
            namesurname: this.fullname,
            username: this.username,
            authority: this.authority,
            supplyId: "",
            email: this.email,
            password: this.password,
            userType: "2",
            customers: [
              {
                customerName: this.customer.name,
                customerId: this.customer.id,
                status: 2,
              },
            ],
          },
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then(() => {
          this.load = false;
          this.$emit("refresh", true);
          this.swalBox(
            "success",
            this.$t("general.successTitle"),
            "Müşteri hesabı başarıyla oluşturuldu",
            false,
            this.$t("general.OkayTitle")
          ).then(() => {
            this.$modal.hide("add-customer-account-modal");
          });
        })
        .catch((err) => {
          this.load = false;
          this.errorBox(err.response);
        });
    },
  },
};
</script>
